export { default } from "./setting.api";
export * from "./setting.api.types";
